import React, { Component } from "react";
import styles from "./detailBloodStationPossibilities.module.scss";
import DetailBloodStation from "../../../entities/detail_blood_station";

import { Popup } from "semantic-ui-react";
import { POSSIBILITIES_TYPES } from "../../../entities/detail_station_possibilities";

export default class DetailBloodStationPossibilities extends Component<
  any,
  any
> {
  props: {
    bloodStation: DetailBloodStation;
  };

  render() {
    const { props } = this;
    const { bloodStation } = props;
    const { for_moscow, with_typing, without_registration } = bloodStation;
    const listOfPossibilities = {
      for_moscow: for_moscow,
      with_typing: with_typing,
      without_registration: without_registration,
    };
    return (
      <div className={styles.DetailBloodStationPossibilities}>
        <div className={styles.DetailBloodStationPossibilities_Body}>
          {Object.keys(POSSIBILITIES_TYPES)
            .filter((key) => listOfPossibilities[key])
            .map((item) => (
              <PossibilitiesItems key={item} PossibilityType={item} />
            ))}
        </div>
      </div>
    );
  }
}

const PossibilitiesItems = ({ PossibilityType }) => {
  const { acceptIcon, text, popup } = POSSIBILITIES_TYPES[PossibilityType];
  return (
    <Popup
      inverted
      basic
      closeOnDocumentClick
      hideOnScroll
      mouseEnterDelay={200}
      hoverable
      style={{ backgroundColor: "#333333" }}
      position={"top center"}
      trigger={
        <div className={styles.DetailBloodStationPossibilities_Body_Item}>
          <div>
            <img src={acceptIcon} alt="" />
          </div>
          <span>{text}</span>
          <div>
            <img src="/static/images/icons/detailBSInfo.svg" alt="" />
          </div>
        </div>
      }
    >
      {popup}
    </Popup>
  );
};
